import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Button, Table, Spinner } from "reactstrap";
import { useCrCustomers } from "./Form/useContractReviewApi";

/**
 * Customer search modal — replaces the legacy CustomerSelect WinForms dialog (Pass 1 §1.10).
 * Server-side substring search against Erp.Customer; debounced as the user types.
 *
 * Returns the selected customer up to the parent via `onPick({ custId, name })`.
 */
export default function CustomerPickerModal({ isOpen, onClose, onPick }) {
    const [q, setQ] = useState("");
    const [debounced, setDebounced] = useState("");

    React.useEffect(() => {
        const t = setTimeout(() => setDebounced(q), 350);
        return () => clearTimeout(t);
    }, [q]);

    const { data, isLoading } = useCrCustomers(debounced, isOpen);

    return (
        <Modal isOpen={isOpen} toggle={onClose} size="lg" backdrop="static">
            <ModalHeader toggle={onClose}>Pick Customer</ModalHeader>
            <ModalBody>
                <Input
                    type="search"
                    placeholder="Search by customer name or ID…"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    autoFocus
                />
                <div className="mt-3" style={{ maxHeight: 360, overflowY: "auto" }}>
                    {isLoading ? (
                        <div className="text-center py-3"><Spinner size="sm" /></div>
                    ) : (
                        <Table size="sm" hover bordered className="mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th style={{ width: "20%" }}>Customer ID</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(data || []).map((c) => (
                                    <tr
                                        key={c.custNum}
                                        onClick={() => onPick({ custId: c.custID, name: c.name })}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <td>{c.custID}</td>
                                        <td>{c.name}</td>
                                    </tr>
                                ))}
                                {(data || []).length === 0 && (
                                    <tr><td colSpan={2} className="text-center text-muted py-3">
                                        {debounced ? "No matching customers." : "Type to search."}
                                    </td></tr>
                                )}
                            </tbody>
                        </Table>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="light" onClick={onClose}>Close</Button>
            </ModalFooter>
        </Modal>
    );
}
